import { SettingsConstants } from '../../constants'

const objFunc = () => {
  return {
    cardTypes: {},
    bridgePayCardTypes: {},
    paymentCards: [],
    disburseCards: [],
    validations: {},
    disburseValidations: {
      maxCardLimit: SettingsConstants.maxDisburseCardLimit
    },
    bridgePayToken: undefined,
    bridgePayDisburseToken: undefined,
    tokenPayInstance: undefined
  }
}

export default objFunc()

export const defaultObj = objFunc()
